/**
 * Clean the CSV in neccesary means
 * @param  {string} csv to clean
 * @return {string}     cleaned
 */
export default function cleanCSV(csv) {
  // Split csv on new line
  // Iterate through each line
  // Clean up rows
  // rejoin
  return csv.split('\n')
    .map((line) => lineSplit(line)
      .map((item, idx, arr) => {
        if (1 < arr.length && arr.every((val) => {
          // Equivalency wasn't seeming to work here - possibly an issue
          // with odd unicode characters not matching. JSON parsing
          // and stringifying seems to rectify the issue.
          const parsedVal = JSON.stringify(JSON.parse(val));
          const parsedFirstEl = JSON.stringify(JSON.parse(arr[0]));
          return parsedVal === parsedFirstEl;
        })) {
          if (0 === idx) {
            return `${item}`;
          }
          return '';
        }
        return item;
      })
      .join(',')
    ).join('\n');
}

function lineSplit(line) {
  const lineElements = [];
  let word = [];
  let insideQuote = false;

  for (let i = 0; i < line.length; i++) { // eslint-disable-line
    if ('"' === line[i] && ('"' !== line[i + 1] && '"' !== line[i - 1])) {
      insideQuote = !insideQuote;
    }
    if ((insideQuote && ',' === line[i]) || ',' !== line[i]) {
      word.push(line[i]);
    }
    if (!insideQuote && ',' === line[i]) {
      lineElements.push(word.join(''));
      word = [];
    }
  }
  lineElements.push(word.join('')); // add on last word
  return lineElements;
}



// WEBPACK FOOTER //
// ./app/services/download/cleanCSV.js